import { render, staticRenderFns } from "./ShareCard.vue?vue&type=template&id=381e99d6&"
import script from "./ShareCard.vue?vue&type=script&lang=js&"
export * from "./ShareCard.vue?vue&type=script&lang=js&"
import style0 from "./ShareCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports